import style from "./style.scss";
import editorialStyle from "../editorial/style.scss";
import { mergeClasses } from "../helpers";

const FixedTable = ({
  frameless = false,
  class: className = null,
  children,
}) => (
  <div
    class={mergeClasses([
      className,
      style.fixedOuter,
      frameless ? style.frameless : null,
    ])}
  >
    <div class={editorialStyle.fixedTable}>{children}</div>
  </div>
);

export default FixedTable;
